(() => {
  if (customElements.get('chapon-home-hero')) return;
  // home-hero.css shows the hero without motion 3s after navigation when this script has not run; the entrance never starts later either.
  const deadline = 3000;

  class ChaponHomeHero extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const signal = this.controller.signal;
      this.reachAchievements();
      // Theme editor: re-measure after a section is reloaded, removed or moved (the observed nodes are replaced or no longer adjacent).
      this.editor?.abort();
      this.editor = new AbortController();
      for (const type of ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder']) globalThis.document?.addEventListener(type, () => requestAnimationFrame(() => this.isConnected && this.reachAchievements()), { signal: this.editor.signal });
      const reveal = () => {
        if (!this.isConnected) return;
        this.classList.add('is-loaded');
        clearTimeout(this.timer);
      };
      // Images still missing at the deadline: show the final state at once (dropping home-motion-ready drops the transitions), never a half-run fade.
      const settle = () => {
        if (!this.isConnected) return;
        this.controller.abort();
        this.classList.remove('home-motion-ready');
        reveal();
      };
      // After home-hero.css's 3s fallback the steam is already shown; do not hide it again.
      if (motion.matches || globalThis.performance?.now() > deadline) {
        reveal();
        return;
      }
      this.classList.add('home-motion-ready');
      // Start after a painted frame so the transitions run from the hidden state (the prototype starts on the next frame).
      const start = () => requestAnimationFrame(() => requestAnimationFrame(reveal));
      // The key copy does not wait for the texture, like the prototype's data-reveal.
      requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-in')));
      // The entrance waits for every image it animates to be loaded and decoded, so it never fades an empty box; a failed image counts as ready.
      const ready = image => (image.complete ? Promise.resolve() : new Promise(resolve => {
        image.addEventListener('load', resolve, { once: true, signal });
        image.addEventListener('error', resolve, { once: true, signal });
      })).then(() => image.decode()).catch(() => {});
      Promise.all([...this.querySelectorAll('.hero__steam, .hero__logo img')].map(ready)).then(() => {
        if (!signal.aborted) start();
      });
      motion.addEventListener('change', reveal, { signal });
      this.timer = setTimeout(settle, deadline - performance.now());
    }

    // The steam runs on behind the Achievements band(s) right below the hero and fades out at their bottom edge (owner, 2026-10-13).
    // Without ResizeObserver or such a band the variable stays unset and the steam fades at the hero's own bottom edge.
    reachAchievements() {
      this.reach?.disconnect();
      const section = this.parentElement;
      if (!globalThis.ResizeObserver || !section) return;
      this.style.removeProperty('--hero-steam-reach');
      const bands = [];
      for (let next = section.nextElementSibling; next?.querySelector(':scope > .ach-placement--band'); next = next.nextElementSibling) bands.push(next);
      if (!bands.length) return;
      const update = () => this.style.setProperty('--hero-steam-reach', `${Math.max(0, Math.round(bands.at(-1).getBoundingClientRect().bottom - this.getBoundingClientRect().bottom))}px`);
      // Its own observer: the entrance's controller is aborted when the entrance settles, the page stays live after that.
      this.reach = new ResizeObserver(update);
      [this, ...bands].forEach(element => this.reach.observe(element));
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.reach?.disconnect();
      this.editor?.abort();
      this.classList.remove('home-motion-ready');
    }
  }
  customElements.define('chapon-home-hero', ChaponHomeHero);
})();
